import React from "react";
import ErrorIcon from "../Icons/ErrorIcon";

interface CallbackErrorStateProps {
  error: string;
  onBackToLogin: () => void;
}

const CallbackErrorState: React.FC<CallbackErrorStateProps> = ({
  error,
  onBackToLogin,
}) => {
  return (
    <div className="w-full max-w-sm flex flex-col items-center">
      <div className="mb-6 flex items-center justify-center">
        <ErrorIcon />
      </div>
      <h2 className="text-2xl font-semibold text-[#1f2937] mb-4 text-center">
        Authentication Error
      </h2>
      <p className="text-sm text-gray-500 text-center mb-6">{error}</p>
      <button
        className="bg-[#4D5874] relative mt-4 flex w-full items-center justify-center rounded-[10px] h-[52px] min-h-[52px] px-4 text-base font-medium text-white transition-all duration-200 hover:bg-[#4D5874]/90 shadow-md"
        onClick={onBackToLogin}
      >
        Back to Login
      </button>
    </div>
  );
};

export default CallbackErrorState;